import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import NavigateIcon from '../../../assests/img/navigate-page.svg?react';
import {convertNumberToSequence} from '../functions/utils';
import {itemsPerPage} from '../../../constants/options';
import '../../../assests/css/pagination.scss';

export interface paginationProps {
    totalPages: number,
    currentPage: number,
    pageStatusText: string,
    setCurrentPage: (page: number) => void,
    customClassName?: string,
}

export default function Pagination(props: paginationProps) {

    const {totalPages, currentPage, pageStatusText,
        customClassName, setCurrentPage} = props;

    const pagesList = convertNumberToSequence(totalPages);
    const [pageNumbers, setPageNumbers] = useState<number[]>([]);

    const onChangePageNumber = (action: 'prev' | 'next' | 'page', page?: number) => {
        switch(action) {
            case 'prev':
                setCurrentPage(currentPage<=1? 1: currentPage-1);
                break;
            case 'next':
                setCurrentPage(currentPage === totalPages?
                    currentPage: currentPage+1);
                break;
            case 'page':
                setCurrentPage(page? page: 1);
                break;
            default: setCurrentPage(1);
        }
        if (action === 'next') {
            if ((currentPage % itemsPerPage) === 0) {
                setPageNumbers(pagesList.slice(currentPage,
                    currentPage+itemsPerPage)) 
            }
        } else if (action === 'prev' || action === 'page') {
            if ((currentPage % itemsPerPage) === 0) {
                setPageNumbers(pagesList.slice(0, currentPage)); 
            }
        } 
    }

    useEffect(()=> {
        setPageNumbers(pagesList.splice(0, itemsPerPage));
    }, [
        totalPages,
    ]);

    return (
        <div className={classNames("pagination-container", customClassName? customClassName : '')}>
            <div className="pagination-content">
                <div className="pagination-item-text">
                    <span className="pagination-status-text">
                        {pageStatusText}
                    </span>
                </div>
                <div className="page-numbers-container">
                    <span className="page-navigation" onClick={()=> onChangePageNumber('prev')}>
                        <NavigateIcon transform='rotate(180)'/>
                    </span>
                    <span className="page-numbers">
                        {pageNumbers.map((page)=> {
                            return (
                                <span key={`page-${page}`} className="page-number-container" onClick={()=> onChangePageNumber('page', page)}>
                                    <span className={
                                        classNames( 'page-number',
                                        page === currentPage? 'selected': '')
                                    }> {page} </span>
                                </span>
                            );
                        })}
                    </span>
                    <span className="page-navigation" onClick={()=> onChangePageNumber('next')}>
                        <NavigateIcon/>
                    </span>
                </div>
            </div>
        </div>
    );

}